import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";

import HomePage from "./pages/public/HomePage";
import MenuPage from "./pages/public/MenuPage";
import ReservationPage from "./pages/public/ReservationPage";
import CartPage from "./pages/public/CartPage";
import TableOrderPage from "./pages/public/TableOrderPage";
import CheckoutSuccess from "./pages/public/CheckoutSuccess";
import LoginPage from "./pages/auth/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPage from "./pages/admin/DashboardPage";
import DishesPage from "./pages/admin/DishesPage";
import ReservationsAdminPage from "./pages/admin/ReservationsAdminPage";
import OrdersPage from "./pages/admin/OrdersPage";
import TablesPage from "./pages/admin/TablesPage";
import EmployeesPage from "./pages/admin/EmployeesPage";
import AttendancePage from "./pages/admin/AttendancePage";
import QuotesAdminPage from "./pages/admin/QuotesAdminPage";
import SettingsPage from "./pages/admin/SettingsPage";
import BadgePage from "./pages/employee/BadgePage";
import QuotePage from "./pages/public/QuotePage";
import BadgeStationPage from "./pages/employee/BadgeStationPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<Navigate to="/commander" replace />} />
            <Route path="/commander" element={<MenuPage />} />
            <Route path="/reservation" element={<ReservationPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/devis" element={<QuotePage />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/table/:qrCodeId" element={<TableOrderPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />

            {/* Auth */}
            <Route path="/login" element={<LoginPage />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="dishes" element={<DishesPage />} />
              <Route path="reservations" element={<ReservationsAdminPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="tables" element={<TablesPage />} />
              <Route path="employees" element={<EmployeesPage />} />
              <Route path="attendance" element={<AttendancePage />} />
              <Route path="quotes" element={<QuotesAdminPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>

            {/* Employee */}
            <Route path="/employee/badge" element={<BadgePage />} />
            <Route path="/pointage" element={<BadgeStationPage />} />
          </Routes>
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
